import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { useUIV2State } from '~hooks/useUIV2State';

import { BusinessProfileUpdateWidget, Subscription } from '~components/index';

import { DashboardWrapperCommonProps } from '../types';

const DashboardWidgetsWrapper = ({
  children,
}: DashboardWrapperCommonProps): ReactElement => {
  const { isEnabledUIV2 } = useUIV2State();

  return (
    <Stack spacing={2} flex={1}>
      <BusinessProfileUpdateWidget />

      {!isEnabledUIV2 && (
        <Subscription.AvailableRoutesState.Alert withButtons withCloseAction />
      )}

      {children}
    </Stack>
  );
};

export default DashboardWidgetsWrapper;
